import React from 'react';
import { Flex, Image, Link, Text,
  Tabs, TabList, TabPanels, Tab, TabPanel, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';

import SchoolTab from '../Components/school/SchoolTab';
import chBanner from '../Resources/Images/Banners/ch_issuer_banner.png';
import enBanner from '../Resources/Images/Banners/en_issuer_banner.png';
import eduIcon from '../Resources/Images/Logos/edu_logo.svg';
import CenterGuideBrick from '../Components/Common/CenterGuideBrick';

const SchoolPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <Flex w='100%' minH='84vh' direction='column' align='center'>
      <Image w='100%' maxH='219px' objectFit='cover' src={i18n.language === 'zh' ? chBanner : enBanner} alt='教育部標章'/>
      <Flex w='85%' h='100%' py='32px' direction='column'>
        <CenterGuideBrick/>
        <Tabs variant='primary'>
          <TabList>
            <Tab textStyle='semibold_md'>{t('school.degreeCertificate')}</Tab>
            <Tab textStyle='semibold_md'>{t('school.teacherCertificate')}</Tab>
          </TabList>
          <TabPanels>
            <TabPanel p='35px 0'>
              <SchoolTab />
            </TabPanel>
            <TabPanel p='35px 0'>
              <Text mb='0px' textStyle='bold_lg' color='text.main'>{t('school.teacherIssuanceUnit')}</Text>
              <Flex w='100%' direction='row' flexWrap='wrap' justify='space-between' mt='0px' mb='0px' pt='0px' pb='0px'>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={eduIcon} alt={i18n.language.includes('zh') ? '教育部' : 'Ministry of Education'}/>
                    <Link href='https://www.edu.tw' target='_blank'
                      _hover={{ color: '#078385' }}
                    >
                      {t('school.edu')}
                    </Link>
                  </Flex>
              </Flex>
              <Text mt='26px' mb='0px' textStyle='bold_lg' color='text.main'>{t('school.langIssuanceUnit')}</Text>
              <Flex w='100%' direction='row' flexWrap='wrap' justify='space-between' mt='0px' mb='0px' pt='0px' pb='0px'>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={'images/logo_standard_SCTOP.png'} alt={i18n.language.includes('zh') ? '華測會' : 'SCTOP'}/>
                    <Link href='https://tocfl.edu.tw/tocfl/' target='_blank'
                      _hover={{ color: '#078385' }}
                    >
                      {t('school.sctop')}
                    </Link>
                  </Flex>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={'images/logo_standard_LTTC.png'} alt={i18n.language.includes('zh') ? '語言中心' : 'LTTC'}/>
                    <Link href='https://www.lttc.ntu.edu.tw' target='_blank'
                      _hover={{ color: '#078385' }}
                    >
                      {t('school.lttc')}
                    </Link>
                  </Flex>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={eduIcon} alt={i18n.language.includes('zh') ? '教育部' : 'Ministry of Education'}/>
                    <Link href='https://depart.moe.edu.tw/ED2400/Default.aspx' target='_blank'
                      _hover={{ color: '#078385' }}
                    >
                      {t('school.moedle')}
                    </Link>
                    &nbsp;-&nbsp;
                    <Link href='https://ttg.moe.edu.tw/tmt/index.php' target='_blank'
                      _hover={{ color: '#078385' }} mt={0} mb={0} pt={0} pb={0}
                    >
                      {t('certCategory.tlpt')}
                    </Link>
                  </Flex>
              </Flex>
              <Text mt='26px' mb='0px' textStyle='bold_lg' color='text.main'>{t('school.creditIssuanceUnit')}</Text>
              <Flex w='100%' direction='row' flexWrap='wrap' justify='space-between' mt='0px' mb='0px' pt='0px' pb='0px'>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={eduIcon} alt={i18n.language.includes('zh') ? '教育部' : 'Ministry of Education'}/>
                    <Link href='https://depart.moe.edu.tw/ED2400/Default.aspx' target='_blank'
                      _hover={{ color: '#078385' }} mt={0} mb={0} pt={0} pb={0}
                    >
                      {t('school.moedle')}
                    </Link>
                    &nbsp;-&nbsp;
                    <Link href='https://lle.moe.edu.tw/life-college' target='_blank'
                      _hover={{ color: '#078385' }} mt={0} mb={0} pt={0} pb={0}
                    >
                      {t('certCategory.tbua')}
                    </Link>
                  </Flex>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={'images/logo_standard_TAICA.png'} alt={i18n.language.includes('zh') ? '人工智慧聯盟' : 'TAICA'}/>
                    <Link href='https://taicatw.net' target='_blank'
                      _hover={{ color: '#078385' }}
                    >
                      {t('school.taica')}
                    </Link>
                  </Flex>
              </Flex>
              <Text mt='26px' mb='0px' textStyle='bold_lg' color='text.main'>{t('school.professionalIssuanceUnit')}</Text>
              <Flex w='100%' direction='row' flexWrap='wrap' justify='space-between' mt='0px' mb='0px' pt='0px' pb='0px'>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={eduIcon} alt={i18n.language.includes('zh') ? '教育部' : 'Ministry of Education'}/>
                    <Link href='https://depart.moe.edu.tw/ED2400/Default.aspx' target='_blank'
                      _hover={{ color: '#078385' }} mt={0} mb={0} pt={0} pb={0}
                    >
                      {t('school.moedle')}
                    </Link>
                    &nbsp;-&nbsp;
                    <Link href='https://moe.senioredu.moe.gov.tw' target='_blank'
                      _hover={{ color: '#078385' }} mt={0} mb={0} pt={0} pb={0}
                    >
                      {t('certCategory.pslp')}
                    </Link>
                  </Flex>
                  <Flex style={cardStyle}>
                    <Image h='100%' maxW='56px' mr='16px' objectFit='contain' src={eduIcon} alt={i18n.language.includes('zh') ? '教育部' : 'Ministry of Education'}/>
                    <Link href='https://depart.moe.edu.tw/ED2400/Default.aspx' target='_blank'
                      _hover={{ color: '#078385' }} mt={0} mb={0} pt={0} pb={0}
                    >
                      {t('school.moedle')}
                    </Link>
                    &nbsp;-&nbsp;
                    <Link href='https://familyedu.moe.gov.tw/moefes/' target='_blank'
                      _hover={{ color: '#078385' }} mt={0} mb={0} pt={0} pb={0}
                    >
                      {t('certCategory.pfep')}
                    </Link>
                  </Flex>
              </Flex>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </Flex>
  )
};

export default SchoolPage;

const cardStyle = {
  width: '45%',
  minWidth: '320px',
  height: '88px',
  padding: '16px 10px',
  margin: '15px 0px',
  alignItems: 'center',
  boxShadow: '4px 8px 10px 0 rgba(194, 211, 220, 0.15), -4px -2px 6px 0 rgba(194, 211, 220, 0.25)',
  borderRadius: '10px'
}
